<div class="view-enter-animation w-full">
  <div class="mobi-ui-grid is-centered">
    <div
      class="max-w-full mobi-ui-col-1/1 mobi-ui-animation-appear-up-init mobi-ui-animation-appear-up-render is-delayed-300"
      [ngClass]="{
        'md:mobi-ui-col-2/3 xl:mobi-ui-col-1/2': !fullWidth(),
      }"
    >
      @if (superTitle()) {
        <span
          class="mobi-ui-font-h4 mobi-ui-text-inked text-animation !pb-0"
          [ngClass]="{ 'text-align-center': isCentered() }"
        >
          <span [innerHTML]="sanitizedSuperTitle()"></span>
        </span>
      }
      @if (title()) {
        <h1
          class="mobi-ui-font-h1 text-animation"
          [class]="{
            'text-align-center': isCentered(),
            '!pb-2': subtitle(),
            'xsMax:!pb-4': !subtitle() && lead(),
          }"
        >
          <span [innerHTML]="sanitizedTitle()"></span>
        </h1>
      }
      @if (subtitle()) {
        <span
          class="mobi-ui-font-h4 mobi-ui-font-bold mobi-ui-font-realist mobi-ui-ink-black text-animation !py-0 mobi-ui-margin-b-sm"
          [ngClass]="{
            'text-align-center': isCentered(),
          }"
        >
          <span [innerHTML]="sanitizedSubtitle()"></span>
        </span>
      }
      @if (lead()) {
        <mobi-text
          class="text-lead block text-animation"
          [ngClass]="{ 'text-align-center': isCentered() }"
          [data]="lead()!"
        />
      }
      @if (contentLinks() && contentLinks()!.length > 0) {
        <div class="mobi-ui-margin-t-xl text-animation">
          <mobi-content-links
            [contentLinks]="contentLinks()!"
            [otherLinks]="otherLinks()!"
          />
        </div>
      }
      @if (primaryCta() || secondaryCta()) {
        <div
          class="hero-ctas mobi-ui-flex mobi-ui-padding-t-xl justify-start"
          [class.hero-ctas--dual]="primaryCta() && secondaryCta()"
        >
          @if (primaryCta()) {
            <mobi-icon-cta
              class="block text-animation"
              [isPrimary]="true"
              [url]="primaryCta()"
              [target]="primaryCtaTarget()"
              [title]="primaryCtaTitle()"
              [icon]="primaryCtaIcon()?.symbol"
            ></mobi-icon-cta>
          }
          @if (secondaryCta()) {
            <mobi-icon-cta
              class="block text-animation"
              [url]="secondaryCta()"
              [target]="secondaryCtaTarget()"
              [title]="secondaryCtaTitle()"
              [secondaryLabel]="secondaryCtaLabel()"
              [icon]="secondaryCtaIcon()?.symbol"
            ></mobi-icon-cta>
          }
        </div>
      }
    </div>
  </div>
</div>
